import { Link } from "react-router-dom";
import { ShieldCheck, ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Brand";

const POINTS = [
  ["Un outil d'accompagnement", "Lisungi est un assistant méthodologique. Il propose des pistes, structure votre pensée et éclaire vos choix, sans jamais décider à votre place."],
  ["Vous restez responsable", "L'utilisateur demeure pleinement responsable de son travail, de son contenu et de son intégrité académique."],
  ["Vérifiez vos références", "Toute référence, citation ou DOI doit être vérifié. Lisungi n'invente jamais de source, mais la validation finale vous appartient."],
  ["Respect des règles académiques", "Vos productions doivent respecter les consignes de votre établissement et les normes académiques en vigueur."],
  ["L'IA ne valide pas la science", "Lisungi ne remplace ni votre encadreur, ni le jury, ni la validation scientifique de vos travaux."],
  ["Protection des données", "Vos documents et données de recherche doivent être protégés. Ne partagez que ce qui est nécessaire."],
];

export default function ResponsibleUse() {
  return (
    <div className="min-h-screen bg-lisungi-bg">
      <nav className="bg-navy"><div className="max-w-4xl mx-auto px-5 h-16 flex items-center justify-between">
        <Logo variant="light" />
        <Link to="/" className="text-sm text-white/80 hover:text-lisungi-yellow flex items-center gap-2"><ArrowLeft className="h-4 w-4" /> Accueil</Link>
      </div></nav>
      <div className="max-w-3xl mx-auto px-5 py-16">
        <div className="h-12 w-12 rounded-xl bg-navy flex items-center justify-center"><ShieldCheck className="h-6 w-6 text-lisungi-yellow" /></div>
        <h1 className="font-serif text-4xl font-bold text-navy mt-5">Utilisation responsable de Lisungi AI</h1>
        <p className="text-muted2 mt-3 leading-relaxed">
          Lisungi AI est conçu par le LARSICOM pour accompagner la recherche en Sciences de l'Information et de la Communication. Son usage suppose le respect de quelques principes essentiels.
        </p>
        <div className="mt-10 space-y-4">
          {POINTS.map(([t, d], i) => (
            <div key={t} className="bg-white rounded-2xl border border-[#E5E7EB] p-6">
              <div className="flex items-center gap-3">
                <span className="h-7 w-7 rounded-full bg-lisungi-yellow text-navy font-bold text-sm flex items-center justify-center">{i + 1}</span>
                <h3 className="font-semibold text-navy text-lg">{t}</h3>
              </div>
              <p className="text-muted2 mt-2 leading-relaxed">{d}</p>
            </div>
          ))}
        </div>
        <div className="mt-8 bg-navy text-white rounded-2xl p-6">
          <p className="font-serif text-xl">« Lisungi accompagne le chercheur, mais ne remplace ni son raisonnement, ni son encadreur, ni la validation scientifique. »</p>
        </div>
      </div>
    </div>
  );
}
